<script>
import Swal from 'sweetalert2';
import rentalCustomerService from '@/api/rentalCustomerService.js';

export default {
  data() {
    return {
      vehicleTypeOptions: [
        { value: null, text: 'Please select an option' },
        { value: 'Car', text: 'Car' },
        { value: 'Motorcycle', text: 'Motorcycle' },
        { value: 'Van', text: 'Van' },
        { value: 'Truck', text: 'Truck' },
        { value: 'Other', text: 'Other' },
      ],
      
      // Form fields
      vehicle_type: null,
      vehicle_make: null,
      vehicle_model: null,
      plate_no: null,
      pickup_date: null,
      pickup_location: null,
      pickup_time: null,
      return_date: null,
      return_location: null,
      return_time: null,
      condition_on_release: null,
      condition_on_return: null,
    };
  },
  props: {
    form_data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    rental_customer_id: {
      type: [Number, String],
      default: null,
    },
    edit_permission: {
      type: Boolean,
      default: false,
    },
    getData: {
      type: Function,
      required: true
    }
  },
  methods: {
    formValidation(e, type = 'text') {
      switch (type) {
        default:
          return e !== null && e !== undefined && e !== '';
      }
    },
    submitHandler() {
      this.$refs.vehicleInfoSubmit.click()
    },
    async detectData() {
      if (this.form_data && this.form_data.id) {
        const {
          vehicle_type,
          vehicle_make,
          vehicle_model,
          plate_no,
          pickup_date,
          pickup_location,
          pickup_time,
          return_date,
          return_location,
          return_time,
          condition_on_release,
          condition_on_return,
        } = this.form_data;

        this.vehicle_type = vehicle_type;
        this.vehicle_make = vehicle_make;
        this.vehicle_model = vehicle_model;
        this.plate_no = plate_no;
        this.pickup_date = pickup_date ? new Date(pickup_date).toISOString().substr(0, 10) : null;
        this.pickup_location = pickup_location;
        this.pickup_time = pickup_time;
        this.return_date = return_date ? new Date(return_date).toISOString().substr(0, 10) : null;
        this.return_location = return_location;
        this.return_time = return_time;
        this.condition_on_release = condition_on_release;
        this.condition_on_return = condition_on_return;
      }
    },
    convertEmptyStringToNull(obj) {
      for (const key in obj) {
        if (obj[key] === '') {
          obj[key] = null;
        }
      }
      return obj;
    },
    saveRentalVehicle() {
      var body = {
        vehicle_type: this.vehicle_type,
        vehicle_make: this.vehicle_make,
        vehicle_model: this.vehicle_model,
        plate_no: this.plate_no,
        pickup_date: this.pickup_date,
        pickup_location: this.pickup_location,
        pickup_time: this.pickup_time,
        return_date: this.return_date,
        return_location: this.return_location,
        return_time: this.return_time,
        condition_on_release: this.condition_on_release,
        condition_on_return: this.condition_on_return,
      }
    
      body = this.convertEmptyStringToNull(body)

      Swal.fire({
        title: 'Confirm',
        text: 'Are you sure you want to submit this rental vehicle information?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.value) {
          const response = await rentalCustomerService.addVehicle(this.rental_customer_id, body);
          
          if (response) {
            Swal.fire({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              icon: 'success',
            });
            
            this.$emit('refresh');
          }
        }
      })
    },
    assignData() {
      setTimeout(() => {
        this.detectData();
      }, 1000);
    },
    onSubmit(e) {
      e.preventDefault();
      this.saveRentalVehicle()
    }
  },
  mounted() {
    this.assignData();
  }
};
</script>

<template>
  <b-form @submit="onSubmit">
    <div class="accordion" role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button class="accordion-button" variant="primary">Vehicle Information</b-button>
        </b-card-header>
        <b-collapse :visible="true">
          <b-card-body>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Type of Vehicle to Rent" label-for="vehicle_type" class="mb-3">
                  <b-form-select
                    id="vehicle_type"
                    style="padding: 0.47rem 0.75rem; font-size: 0.9rem; width: 100%; height: 100%;"
                    :disabled="edit_permission" 
                    v-model="vehicle_type"
                    :options="vehicleTypeOptions"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Vehicle Make" label-for="vehicle_make" class="mb-3">
                  <b-form-input :disabled="edit_permission" v-model="vehicle_make" id="vehicle_make" type="text" :state="formValidation(vehicle_make)" required></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Vehicle Model" label-for="vehicle_model" class="mb-3">
                  <b-form-input :disabled="edit_permission" v-model="vehicle_model" id="vehicle_model" type="text" :state="formValidation(vehicle_model)" required></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Vehicle Plate No." label-for="plate_no" class="mb-3">
                  <b-form-input :disabled="edit_permission" v-model="plate_no" id="plate_no" type="text" :state="formValidation(plate_no)" required></b-form-input>
                </b-form-group>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button class="accordion-button" variant="primary">Rental Details</b-button>
        </b-card-header>
        <b-collapse :visible="true">
          <b-card-body>
            <div class="row">
              <div class="col-md-4">
                <b-form-group label="Date of Customer Pick Up" label-for="pickup_date" class="mb-3">
                  <b-form-input :disabled="edit_permission" v-model="pickup_date" id="pickup_date" type="date" :state="formValidation(pickup_date)" required></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="Place / Location of Pickup" label-for="pickup_location" class="mb-3">
                  <b-form-input :disabled="edit_permission" v-model="pickup_location" id="pickup_location" type="text" :state="formValidation(pickup_location)" required></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="Time of Pick Up" label-for="pickup_time" class="mb-3">
                  <b-form-input :disabled="edit_permission" v-model="pickup_time" id="pickup_time" type="time" :state="formValidation(pickup_time)" required></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <b-form-group label="Date of Customer Return" label-for="return_date" class="mb-3">
                  <b-form-input :disabled="edit_permission" v-model="return_date" id="return_date" type="date" :state="formValidation(return_date)" required></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="Place / Location of Return" label-for="return_location" class="mb-3">
                  <b-form-input :disabled="edit_permission" v-model="return_location" id="return_location" type="text" :state="formValidation(return_location)" required></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="Time of Return" label-for="return_time" class="mb-3">
                  <b-form-input :disabled="edit_permission" v-model="return_time" id="return_time" type="time" :state="formValidation(return_time)" required></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Condition of Vehicle on Release to Customer" label-for="condition_on_release" class="mb-3">
                  <b-form-textarea :disabled="edit_permission" v-model="condition_on_release" id="condition_on_release" rows="3" :state="formValidation(condition_on_release)" required></b-form-textarea>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Condition of Vehicle on Return by Customer" label-for="condition_on_return" class="mb-3">
                  <b-form-textarea :disabled="edit_permission" v-model="condition_on_return" id="condition_on_return" rows="3"></b-form-textarea>
                </b-form-group>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <br>
    <b-button v-if="!edit_permission && rental_customer_id" ref="vehicleInfoSubmit" type="submit" variant="primary" >
      Save Vehicle Information
    </b-button>
  </b-form>
</template>

<style lang="scss"></style>
